import React from 'react';
import cx from 'classnames';

import styles from './style.module.scss';

// We are not using react-bootstrap here to save page size. These are simplified buttons for
// the marketing pages only.

interface Props {
  block?: boolean;
  children: any;
  className?: string;
  disabled?: boolean;
  href?: string;
  onClick?: (any) => void;
  size?: null | 'sm';
  style?: any;
}

export const GreenButton = (props: Props) => {
  return (
    <a
      {...props}
      className={cx(
        styles.greenButton,
        props.className,
        {
          [styles.buttonBlock]: !!props.block,
          [styles.buttonDisabled]: !!props.disabled,
          [styles.buttonSmall]: props.size === 'sm'
        }
      )}
    />
  );
};

export const PurpleButton = (props: Props) => {
  return (
    <a
      {...props}
      className={cx(
        styles.purpleButton,
        props.className,
        {
          [styles.buttonBlock]: !!props.block,
          [styles.buttonDisabled]: !!props.disabled,
          [styles.buttonSmall]: props.size === 'sm'
        }
      )}
    />
  );
};

export const WhiteButton = (props: Props) => {
  return (
    <a
      {...props}
      className={cx(
        styles.whiteButton,
        props.className,
        {
          [styles.buttonBlock]: !!props.block,
          [styles.buttonDisabled]: !!props.disabled,
          [styles.buttonSmall]: props.size === 'sm'
        }
      )}
    />
  );
};

export const YellowButton = (props: Props) => {
  return (
    <a
      {...props}
      className={cx(
        styles.yellowButton,
        props.className,
        {
          [styles.buttonBlock]: !!props.block,
          [styles.buttonDisabled]: !!props.disabled,
          [styles.buttonSmall]: props.size === 'sm'
        }
      )}
    />
  );
};
